export default __webpack_public_path__ + "static/media/hamsterbg.d7663d80.svg";